module.exports = __webpack_public_path__ + "static/media/SEG Y SALUD.0471f1d3.png";